import { EmploymentType } from '~Data';

export const employmentTypeChoices: Record<EmploymentType, string> = {
  [EmploymentType.Contract]: 'Contract',
  [EmploymentType.FullTime]: 'Full-time',
  [EmploymentType.PartTime]: 'Part-time',
  [EmploymentType.Permanent]: 'Permanent',
  [EmploymentType.Temporary]: 'Temporary',
};
